import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PatientSpaceService } from '../../_services/patient-space/patient-space.service';

@Component({
  selector: 'app-patient-purchases',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './patient-purchases.component.html',
  styleUrl: './patient-purchases.component.scss',
})
export class PatientPurchasesComponent implements OnInit {
  loading = true;
  rows: any[] = [];

  constructor(private readonly patientSpaceService: PatientSpaceService) {}

  ngOnInit(): void {
    this.patientSpaceService.purchases().subscribe({
      next: (response: any) => {
        this.rows = Array.isArray(response) ? response : [];
        this.loading = false;
      },
      error: () => {
        this.rows = [];
        this.loading = false;
      },
    });
  }
}
